import type { FC } from 'react'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'

interface CollectionSearchProps {
  value: string
  onChange: (value: string) => void
  onClear: () => void
}

export const CollectionSearch: FC<CollectionSearchProps> = ({ value, onChange, onClear }) => (
  <div className="px-4 py-3">
    <label className="sr-only" htmlFor="word-collection-search">
      Search word collection
    </label>
    <div className="flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-600">
      <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" aria-hidden />
      <input
        id="word-collection-search"
        data-testid="word-collection-search-input"
        className="flex-1 border-none bg-transparent text-sm focus:outline-none"
        placeholder="Search words"
        aria-label="Filter the word collection"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {value && (
        <button
          type="button"
          onClick={onClear}
          className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-gray-500 hover:text-gray-700"
          aria-label="Clear search"
          data-testid="word-collection-search-clear"
        >
          <XMarkIcon className="h-3 w-3" aria-hidden />
        </button>
      )}
    </div>
  </div>
)

export default CollectionSearch
